import { FunctionComponent } from "react";
import React from "react";
import { ThemeProvider } from "styled-components";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import { MainTheme } from "../shared/Theme";
import GlobalStyles from "../styles/GlobalStyles";
import { Script } from "gatsby";


interface Props {
  children: any;
  pageContext: any;
  path: string;
}

const Layout: FunctionComponent<Props> = ({ path, children, pageContext }) => {

  if (pageContext.layout === "404") {
    // @ts-ignore
    return <ThemeProvider theme={MainTheme}>{children}</ThemeProvider>;
  } else {
    return (
      <>
        {/* @ts-ignore */}
        <ThemeProvider theme={MainTheme}>
          {/* @ts-ignore */}
          <GlobalStyles />
          {!path.startsWith("/serwis-opon") && <Navbar path={path} />}
          {children}
          <Footer />
        </ThemeProvider>
      </>
    );
  }
};


export default Layout;
